import WorkoutsAbandonedModal from './WorkoutsAbandonedModal';

export default WorkoutsAbandonedModal;
